<template>
    <div class="login-content-wrapper">
        <div class="img-desktop d-none d-lg-inline-block img-desktop-login"></div>
        <section class="content">
            <div class="container-fluid">
<!--                <div class="login-logo-container">-->
<!--                    <img src="@/assets/img/logoAfflexBaseline.png" alt="Afflex logo">-->
<!--                </div>-->
                <div class="row mt-4">
                    <div class="col-md-6 form-request-content">
                        <!-- Incorrect email alert -->
                        <div v-show="showErrorMessage"
                             class="alert alert-warning alert-dismissible"
                        >
                            <button type="button"
                                    class="close"
                                    @click="showErrorMessage = !showErrorMessage"
                            >×</button>
                            <h5>
                                <i class="icon fas fa-exclamation-triangle"></i>
                                <span>Le jeton de récupération de mot de passe n'est plus valide</span>
                            </h5>
                        </div>
                        <!-- Incorrect email alert -->

                        <form novalidate="novalidate"
                              class="needs-validation"
                        >
                            <!-- New password -->
                            <label class="required-field-asterisks required"
                                   for="new-password"
                            >Nouveau mot de passe</label>
                            <input type="password"
                                   id="new-password"
                                   class="form-control form-control-lg"
                                   placeholder="Nouveau mot de passe"
                                   :class="{ 'is-invalid': $v.formData.newPassword.$error }"
                                   @input="delayTouch($v.formData.newPassword)"
                                   v-model="formData.newPassword"
                            >
                            <FormError v-if="!$v.formData.newPassword.required && $v.formData.newPassword.$dirty"
                                       error="Veuillez renseigner la mot de passe"
                            ></FormError>
                            <FormError v-if="!$v.formData.newPassword.minLength && $v.formData.newPassword.$dirty"
                                       error="Le mot de passe doit contenir au moins 12 caractères."
                            ></FormError>
                            <FormError v-if="!$v.formData.newPassword.passwordComplexity && $v.formData.newPassword.$dirty"
                                       error="Le mot de passe doit contenir au moins une majuscule, une minuscule et un chiffre."
                            ></FormError>
                            <!-- New password -->

                            <!-- New password -->
                            <label class="required-field-asterisks required"
                                   for="repeated-new-password"
                            >Confirmation du mot de passe</label>
                            <input type="password"
                                   id="repeated-new-password"
                                   class="form-control form-control-lg"
                                   placeholder="Nouveau mot de passe "
                                   :class="{ 'is-invalid': $v.formData.repeatedNewPassword.$error }"
                                   @input="delayTouch($v.formData.repeatedNewPassword)"
                                   v-model="formData.repeatedNewPassword"
                            >
                            <FormError v-if="$v.formData.repeatedNewPassword.$error"
                                       error="Les mots de passe ne correspondent pas"
                            ></FormError>
                            <!-- New password -->
                        </form>
                    </div>

                    <div class="input-group col-md-10 mx-sm-auto my-md-4">
                        <div class="mx-sm-auto">
                            <button class="btn btn-success btn-lg ml-4 btn-link btn__save"
                                    :disabled="isLoading || $v.$invalid"
                                    @click.prevent="submit"
                            >
                                <span>Changer le mot de passe</span>
                                <ButtonSpinner :isLoading="isLoading"></ButtonSpinner>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import ButtonSpinner from '../../components/ButtonSpinner';
import ValidationDelayTouch from '../../mixins/validationDelayTouch';
import FormError from '../../components/FormError';
import { required, minLength, helpers } from 'vuelidate/lib/validators';

const passwordComplexity = helpers.regex('complexity', /(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/);
import { confirmPasswordReset } from '../../service/api/user.api';
import { messageTexts, successMessage } from '../../utils/sweet-alert-options';

export default {
    mixins: [ValidationDelayTouch],
    data() {
        return {
            formData: {
                newPassword: '',
                repeatedNewPassword: ''
            },
            showErrorMessage: false,
            isLoading: false
        };
    },
    computed: {
        resetPasswordToken() {
            return this.$route.params.resetPasswordToken;
        }
    },
    methods: {
        async submit() {
            this.isLoading = true;
            this.showErrorMessage = false;
            try {
                await confirmPasswordReset(this.resetPasswordToken, {
                    plainPassword: this.formData.newPassword,
                });
                this.isLoading = false;
                await this.$router.push({ name: 'login' });
                this.$swal({ title: messageTexts.passwordSuccessfullyChanged, ...successMessage });
            } catch (e) {
                this.isLoading = false;
                this.showErrorMessage = true;
            }
        }
    },
    validations: {
        formData: {
            newPassword: {
                required,
                minLength: minLength(12),
                passwordComplexity
            },
            repeatedNewPassword: {
                required,
                sameAsNewPassword: function (value) {
                    return value === this.formData.newPassword;
                }
            }
        }
    },
    components: {
        ButtonSpinner,
        FormError
    }
}
</script>

<style scoped lang="scss">
    p {
        margin-bottom: 0;
    }
</style>
